enum MazeGameStatusEnum {
  WAITING_TURN,
  DRAWING_LINE,
  USER_LOST,
  USER_WON,
}

export default MazeGameStatusEnum;
